import styled from "styled-components";
import theme from "./../../styles/theme"

export const ReportSection = styled.section`
    padding-top: 100px;

    @media (max-width:  ${theme.breakpoints.medium}){
      padding-top: 35px;
    }
`;
export const ReportDescription = styled.div`
  display: flex;
  padding-right: 50px;

  @media (max-width: ${theme.breakpoints.medium}) {
    flex-direction: column;
    padding: 0;
  }
`;

export const ReportBox = styled.div`
  background: ${theme.colors.black};
  display: flex;
  width: 100%;
  align-items: end;
  position: relative;

  div:first-child{
    width: 40%;
    position: absolute;
  }

  @media (max-width: ${theme.breakpoints.medium}) {
    flex-direction: column-reverse;
    align-items: baseline;
    padding: 0;
    position: initial;

    div:first-child{
      width: 30%;
      position: initial;
    }
  }
`;

export const ReportWrapper = styled.div`
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  right: 20%;
  top: 25%;
  width: 290px;
  @media (max-width: 1500px){
    right: 10%;
    top: 20%;
  }
  @media (max-width: ${theme.breakpoints.medium}) {
    padding: 40px;
    position: initial;
    width: 100%;
  }
`;
export const ReportTitle = styled.h3`
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-weight: ${theme.fontWeights.bold} !important;
  font-size: 34px;
  line-height: 41px;
  color: ${theme.colors.white};
  text-align: left;
  padding-bottom: 10px;
`;
export const ReportHR = styled.hr`
  width: 10%;
  border: 2px solid  ${theme.colors.landingTheme};
`;
export const ReportSubTitle = styled.p`
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-weight: 500;
  font-size: ${theme.fontSizes.small};
  line-height: 22px;
  color: ${theme.colors.white};
  text-align: left;
  padding-top: 30px;

  a {
    color: #fff;
  }
`;

export const ReportVideo = styled.div`
  padding: 20px;
  margin-left: -70px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 1;

  @media (max-width:1500px){
    margin-left: -40px;
  }


  @media (max-width: ${theme.breakpoints.medium}){
    margin-left: 0;
    margin-top: -100px;

    iframe{
      width: 100%;
      height: 210px;
    }
  }
`;

export const ReportDocuments = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 80px;

  @media (max-width: ${theme.breakpoints.medium}){
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

export const ReportDocumentswrapper = styled.div`
  background: ${theme.colors.white};
  border: 1px solid rgba(225, 225, 225, 0.3);
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 12px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  width: 70%;
  padding: 20px;

  @media (max-width: ${theme.breakpoints.medium}){
    width: 90%;
  }
`;

export const ReportDocumentsBox = styled.div`
  height: 215px;
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 20px 40px;
  direction: rtl;
  text-align: left;

  @media (max-width: ${theme.breakpoints.medium}){
    height: 280px;
    padding: 20px;
  }

    ::-webkit-scrollbar {
      width: 4px;
      height: 140px;
      direction: rtl;
      margin: 20px;
    }
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px grey;
      border-radius: 10px;
      background: #DDDDDD;
    }
    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.black};
      border-radius: 10px;
    }
`;


export const ReportDocumentsLink = styled.a`
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-weight: ${theme.fontWeights.bold};
  font-size: 15px;
  line-height: 24px;
  text-decoration-line: underline;
  color: #898989 !important;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row-reverse;
  gap: 10px;
  -webkit-transition: font-size .3s ease;
  -moz-transition: font-size .3s ease;
  -o-transition: font-size .3s ease;
  transition: font-size .3s ease;

  @media (max-width: ${theme.breakpoints.medium}){
    font-size: 12px;
    gap: 0;
    div:first-child{
      width: 15px;
      margin-right: 10px;
    }
  }

  &:hover{
    font-weight: ${theme.fontWeights.bold};
    font-size: 22px;
    line-height: 27px;
    color: ${theme.colors.gray};

    div:first-child{
      width: 30px;
      height: 40px;
      opacity: 1;
    }

    @media (max-width: ${theme.breakpoints.medium}){
      font-size: ${theme.fontSizes.small};
    }
  }

`;

export const ReportDocumentsLinkImg = styled.div`
  width: 20px;
  height: 30px;
  -webkit-transition: .3s ease;
  -moz-transition: .3s ease;
  -o-transition: .3s ease;
  transition: .3s ease;
  opacity: 0.5;
`;

export const ReportDocumentsTitleBox = styled.div`
  padding-top: 100px;
`;

export const ReportDocumentsTitle = styled.h3`
  font-family: ${theme.fonts.montSerrat};
  font-style: normal;
  font-weight: ${theme.fontWeights.bold} !important;
  font-size: ${theme.fontSizes.xxLarge};
  line-height: 44px;
  color: ${theme.colors.gray};
`;
